document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-variant-selects]').forEach((wrap) => {
    const productId = wrap.getAttribute('data-product-id');
    const jsonEl = document.getElementById(`ProductVariants-${productId}`);
    if (!jsonEl) return;

    const variants = JSON.parse(jsonEl.textContent || '[]');
    const selects = Array.from(wrap.querySelectorAll('select[data-option-index]'));
    if (!selects.length) return;

    const form = wrap.closest('form');
    const errorEl = wrap.querySelector('[data-vs-error]');

    // Shopify "real" variant id input/select in the form
    const variantIdField =
      form?.querySelector('select[name="id"], input[name="id"]') ||
      document.querySelector('select[name="id"], input[name="id"]');

    // Add to cart button (disable until valid)
    const addToCartBtn =
      form?.querySelector('[type="submit"]') ||
      document.querySelector('[type="submit"]');

    function getSelections() {
      const selections = [];
      selects.forEach((sel) => {
        const idx = Number(sel.dataset.optionIndex);
        selections[idx] = sel.value || null; // null when "Please select"
      });
      return selections;
    }

    function allSelected(selections) {
      return selections.every(v => v && v.length);
    }

    function findMatchingVariant(selections) {
      return variants.find((v) => v.options.every((opt, i) => opt === selections[i]));
    }

    function computeAllowedValues(optionIndex, selections) {
      const allowed = new Set();
      variants.forEach((v) => {
        if (!v.available) return;

        // Must match all OTHER selected options (ignore nulls)
        for (let i = 0; i < selections.length; i++) {
          if (i === optionIndex) continue;
          if (selections[i] && v.options[i] !== selections[i]) return;
        }

        allowed.add(v.options[optionIndex]);
      });
      return allowed;
    }

    function updateOptionAvailability() {
      const selections = getSelections();

      selects.forEach((sel) => {
        const idx = Number(sel.dataset.optionIndex);
        const allowed = computeAllowedValues(idx, selections);

        Array.from(sel.options).forEach((opt) => {
          // Keep placeholder enabled always
          if (opt.value === '') {
            opt.disabled = false;
            return;
          }
          opt.disabled = !allowed.has(opt.value);
        });

        // If currently selected value becomes invalid, reset to placeholder
        const selectedOpt = sel.options[sel.selectedIndex];
        if (selectedOpt && selectedOpt.disabled) {
          sel.value = '';
        }
      });
    }

    function setUIStateComplete(isComplete) {
      if (addToCartBtn) addToCartBtn.disabled = !isComplete;
      if (errorEl) errorEl.style.display = isComplete ? 'none' : 'block';
    }

    function syncToShopifyVariant() {
      const selections = getSelections();

      // If not all selected, do not set a variant id (and disable ATC)
      if (!allSelected(selections)) {
        setUIStateComplete(false);
        return;
      }

      const match = findMatchingVariant(selections);
      if (!match) {
        setUIStateComplete(false);
        return;
      }

      setUIStateComplete(true);

      if (!variantIdField) return;

      variantIdField.value = String(match.id);
      variantIdField.dispatchEvent(new Event('change', { bubbles: true }));
    }

    // Bind change events
    selects.forEach((sel) => {
      sel.addEventListener('change', () => {
        updateOptionAvailability();
        syncToShopifyVariant();
      });
    });

    // Initial state: placeholder + disabled ATC until selection
    updateOptionAvailability();
    syncToShopifyVariant();
  });
});
